/**
 * Build-your-bundle page behavior (sections/featured-bundle.liquid).
 *
 * Every featured-bundle section on the page loads this file, so it guards against running more than once.
 * All state lives in a single `bundle` list (one entry per product with a quantity) and every control on
 * the page -- product card + / - buttons, the slots in the "Your Bundle" box, the totals and the submit
 * button -- is redrawn from that list in render(). Nothing keeps its own copy of the state.
 */
(function () {
  if (window.__fiveBundleBuilder) return;
  window.__fiveBundleBuilder = true;

  var MAX_PRODUCTS = 3;
  var DISCOUNT_CODE = 'BUNDLE15';
  var ONE_TIME_DISCOUNT = 0.15;
  var SCROLL_OFFSET = 150;
  var MOBILE_MAX_WIDTH = 768;

  var REMOVE_ICON =
    '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" class="remove-product" role="button" aria-label="Remove from bundle"><g clip-path="url(#clip0_596_9633)">' +
    '<rect width="28" height="28" fill="#333333"/>' +
    '<g clip-path="url(#clip1_596_9633)">' +
    '<path d="M9.21916 8.76077C8.40936 8.76077 7.64256 8.76346 6.87486 8.7545C6.8247 8.7545 6.73153 8.6694 6.73153 8.62282C6.72257 7.84796 6.72526 7.07399 6.72526 6.26509C6.94025 6.26509 7.13106 6.26509 7.32276 6.26509C7.8889 6.26509 8.45504 6.26061 9.02118 6.27136C9.08837 6.27225 9.2102 6.35646 9.21109 6.40304C9.22274 7.177 9.21916 7.95187 9.21916 8.75987V8.76077Z" fill="white"/>' +
    '<path d="M19.1696 8.72776C19.1696 7.94753 19.1678 7.17983 19.175 6.41213C19.175 6.36376 19.2476 6.27418 19.2879 6.27329C20.0699 6.26522 20.8519 6.26702 21.6662 6.26702C21.6662 6.60563 21.6662 6.91915 21.6662 7.23179C21.6662 7.677 21.6644 8.12131 21.6671 8.56652C21.668 8.68745 21.6519 8.76449 21.4996 8.7636C20.7552 8.75733 20.0117 8.76001 19.2673 8.75822C19.2449 8.75822 19.2225 8.74478 19.1705 8.72866L19.1696 8.72776Z" fill="white"/>' +
    '<path d="M6.72436 21.2062C6.72436 20.3919 6.72257 19.617 6.72974 18.8422C6.72974 18.7983 6.81125 18.7176 6.85604 18.7167C7.63091 18.7087 8.40577 18.7114 9.19586 18.7114C9.20482 18.792 9.21736 18.8538 9.21825 18.9147C9.22005 19.6027 9.21377 20.2898 9.22273 20.9777C9.22542 21.1605 9.16988 21.2124 8.98893 21.2106C8.24632 21.2017 7.5037 21.2071 6.72346 21.2071L6.72436 21.2062Z" fill="white"/>' +
    '<path d="M21.6644 21.2061C21.2479 21.2061 20.8618 21.2061 20.4757 21.2061C20.104 21.2061 19.7313 21.2025 19.3596 21.2078C19.2332 21.2096 19.1661 21.1828 19.167 21.035C19.1723 20.2753 19.1696 19.5148 19.1696 18.7355C19.2422 18.7256 19.3031 18.7113 19.3631 18.7113C20.0592 18.7095 20.7543 18.7113 21.4503 18.7095C21.5731 18.7095 21.6689 18.7095 21.668 18.8815C21.6617 19.6411 21.6653 20.4016 21.6653 21.2061H21.6644Z" fill="white"/>' +
    '<path d="M4.24928 3.78833H6.70376V6.24818H4.24928V3.78833Z" fill="white"/>' +
    '<path d="M21.6806 3.78833H24.135V6.24639H21.6806V3.78833Z" fill="white"/>' +
    '<path d="M11.7193 11.253H9.23528V8.77612H11.7121V11.2602L11.7184 11.2539L11.7193 11.253Z" fill="white"/>' +
    '<path d="M16.6937 8.77344H19.1499V11.2342H16.6937V8.77344Z" fill="white"/>' +
    '<path d="M11.7121 11.2601H14.1989C14.1989 12.086 14.1989 12.9075 14.1989 13.7298L14.206 13.7217H11.7193C11.7193 12.8949 11.7193 12.0744 11.7193 11.2529L11.713 11.2592L11.7121 11.2601Z" fill="white"/>' +
    '<path d="M16.6748 16.2103H14.2051C14.2051 15.3799 14.2051 14.5513 14.2051 13.7227C14.2051 13.7227 14.198 13.7307 14.1989 13.7298C15.0149 13.7298 15.831 13.7298 16.6686 13.7298V16.2165L16.6748 16.2103Z" fill="white"/>' +
    '<path d="M9.23259 18.6953V16.239H11.6924V18.6953H9.23259Z" fill="white"/>' +
    '<path d="M16.6686 16.2167H19.1535V18.6945H16.6749C16.6749 17.856 16.6749 17.0328 16.6749 16.2104L16.6686 16.2167Z" fill="white"/>' +
    '<path d="M6.70824 23.6813H4.25465V21.2241H6.70824V23.6813Z" fill="white"/>' +
    '<path d="M21.6806 23.6776V21.2285H24.1341V23.6776H21.6806Z" fill="white"/>' +
    '<path d="M14.2087 11.261H16.665V13.7217H14.2087V11.261Z" fill="white"/>' +
    '<path d="M14.1881 16.2103H11.7184C11.7184 15.3799 11.7184 14.5513 11.7184 13.7227C11.7184 13.7227 11.7112 13.7307 11.7121 13.7298C12.5282 13.7298 13.3443 13.7298 14.1819 13.7298V16.2165L14.1881 16.2103Z" fill="white"/>' +
    '</g></g>' +
    '<defs><clipPath id="clip0_596_9633"><rect width="28" height="28" fill="white"/></clipPath>' +
    '<clipPath id="clip1_596_9633"><rect width="19.8929" height="19.8929" fill="white" transform="translate(4 4)"/></clipPath></defs></svg>';

  var bundle = []; // [{ id, name, image, oneTimePrice, qty }]
  var isMobileBoxOpen = false;
  var isSubmitting = false;

  /* ---------- helpers ---------- */

  function parsePrice(value) {
    var n = parseFloat(String(value || '').replace(/[^0-9.-]+/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function formatPrice(n) {
    return '$' + n.toFixed(2);
  }

  function totalCount() {
    return bundle.reduce(function (sum, p) { return sum + p.qty; }, 0);
  }

  function findEntry(id) {
    for (var i = 0; i < bundle.length; i++) {
      if (bundle[i].id === id) return bundle[i];
    }
    return null;
  }

  function setText(selector, text) {
    var el = document.querySelector(selector);
    if (el) el.textContent = text;
  }

  /* ---------- bundle state ---------- */

  function addUnit(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id || totalCount() >= MAX_PRODUCTS) return;

    var entry = findEntry(id);
    if (entry) {
      entry.qty++;
    } else {
      bundle.push({
        id: id,
        name: btn.getAttribute('data-prod-name') || '',
        image: (btn.getAttribute('data-prod-image') || '').trim(),
        oneTimePrice: parsePrice(btn.getAttribute('data-one-time-price')),
        qty: 1
      });
    }
    render();
  }

  function removeUnit(id) {
    var entry = findEntry(id);
    if (!entry) return;
    entry.qty--;
    if (entry.qty <= 0) bundle.splice(bundle.indexOf(entry), 1);
    render();
  }

  /* ---------- rendering ---------- */

  function renderCards() {
    var full = totalCount() >= MAX_PRODUCTS;

    document.querySelectorAll('.quantity-selector-one').forEach(function (selector) {
      var entry = findEntry(selector.getAttribute('data-product-id'));
      var qty = entry ? entry.qty : 0;
      var initialBtn = selector.parentElement.querySelector('.initial-plus-btn');

      selector.style.display = qty > 0 ? 'flex' : 'none';
      if (initialBtn) {
        initialBtn.style.display = qty > 0 ? 'none' : '';
        initialBtn.classList.toggle('disabled', full);
        initialBtn.setAttribute('aria-disabled', full ? 'true' : 'false');
      }

      var qtyEl = selector.querySelector('.quantity-input-one');
      if (qtyEl) qtyEl.textContent = qty;

      var plusBtn = selector.querySelector('.plus-one');
      if (plusBtn) {
        plusBtn.disabled = full;
        plusBtn.classList.toggle('disabled', full);
      }
    });
  }

  function renderSlots() {
    var area = document.querySelector('.bundle-select-area');
    if (!area) return;

    var units = [];
    bundle.forEach(function (p) {
      for (var i = 0; i < p.qty; i++) units.push(p);
    });

    area.querySelectorAll('.bundle-col').forEach(function (col, index) {
      var unit = units[index];
      var imgWrap = col.querySelector('.bunle-img');
      var nameEl = col.querySelector('p');
      if (!nameEl) {
        nameEl = document.createElement('p');
        col.appendChild(nameEl);
      }

      imgWrap.innerHTML = '';
      col.classList.toggle('empty-bundle', !unit);
      nameEl.textContent = unit ? unit.name : '';
      if (!unit) return;

      if (unit.image) {
        var img = document.createElement('img');
        img.className = 'img-fluid lazyload';
        img.loading = 'lazy';
        img.src = unit.image;
        img.alt = unit.name;
        imgWrap.appendChild(img);
      }
      imgWrap.insertAdjacentHTML('beforeend', REMOVE_ICON);
      var removeIcon = imgWrap.querySelector('.remove-product');
      removeIcon.setAttribute('data-pid', unit.id);
      removeIcon.setAttribute('tabindex', '0');
    });
  }

  function renderTotals() {
    var oneTime = 0;
    bundle.forEach(function (p) {
      oneTime += p.oneTimePrice * p.qty;
    });

    setText('.product_count', totalCount());
    setText('#total-one-time-price', formatPrice(oneTime));
    setText('#one-time-strike-price', formatPrice(oneTime * (1 - ONE_TIME_DISCOUNT)));
  }

  function renderSubmit() {
    var submit = document.getElementById('bundle-submit');
    if (submit) submit.disabled = isSubmitting || totalCount() < MAX_PRODUCTS;
  }

  function render() {
    renderCards();
    renderSlots();
    renderTotals();
    renderSubmit();

    // On mobile the bundle box is collapsed until the first product is picked.
    if (window.innerWidth <= MOBILE_MAX_WIDTH && totalCount() === 1 && !isMobileBoxOpen) {
      toggleMobileBox();
    }
  }

  /* ---------- mobile bundle box ---------- */

  function slideDown(element, duration) {
    element.style.removeProperty('display');
    if (window.getComputedStyle(element).display === 'none') element.style.display = 'block';

    var height = element.scrollHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.transition = 'height ' + duration + 'ms ease-in-out';
    requestAnimationFrame(function () { element.style.height = height + 'px'; });

    setTimeout(function () {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }

  function slideUp(element, duration) {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.style.transition = 'height ' + duration + 'ms ease-in-out';
    requestAnimationFrame(function () { element.style.height = '0'; });

    setTimeout(function () {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }

  function toggleMobileBox() {
    var content = document.querySelector('.bundle-box-right-content');
    var caret = document.querySelector('.caret-icon');
    var close = document.querySelector('.close-icon');
    if (!content || !caret || !close) return;

    if (isMobileBoxOpen) {
      slideUp(content, 500);
      caret.style.display = 'block';
      close.style.display = 'none';
    } else {
      slideDown(content, 500);
      caret.style.display = 'none';
      close.style.display = 'block';
    }
    isMobileBoxOpen = !isMobileBoxOpen;
  }

  /* ---------- discount + cart ---------- */

  // AfterSell's SDK has no discount action (https://docs.aftersell.com/aftersell/cart/sdk-actions),
  // so the code is set on the Shopify cart directly and AfterSell is told to refetch the cart to show it.
  async function refreshAftersellCart() {
    var cart = window.aftersell && window.aftersell.cart;
    if (!cart || !cart.actions) return;
    if (typeof cart.ready === 'function') await cart.ready();
    await cart.actions.refresh();
  }

  // The items are already in the cart when this runs, so a discount failure must not fail the bundle.
  async function applyBundleDiscount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: DISCOUNT_CODE })
      });
      if (!response.ok) throw new Error('cart/update.js responded ' + response.status);
    } catch (error) {
      console.warn('Could not apply ' + DISCOUNT_CODE + '.', error);
    }

    try {
      await refreshAftersellCart();
    } catch (error) {
      console.warn('Could not refresh the AfterSell cart.', error);
    }
  }

  function showError(message) {
    var form = document.getElementById('product-bundle-form');
    if (!form) return;
    var el = form.querySelector('.bundle-error');
    if (!el && !message) return;
    if (!el) {
      el = document.createElement('p');
      el.className = 'bundle-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#CD434B;text-align:center;margin:10px 0 0;font-size:14px;';
      form.appendChild(el);
    }
    el.textContent = message || '';
  }

  async function submitBundle() {
    if (isSubmitting || totalCount() < MAX_PRODUCTS) return;

    var submit = document.getElementById('bundle-submit');

    isSubmitting = true;
    showError('');
    if (submit) submit.classList.add('loading');
    renderSubmit();

    var items = bundle.map(function (p) {
      return { id: p.id, quantity: p.qty };
    });

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        var detail = await response.json().catch(function () { return null; });
        throw new Error((detail && (detail.description || detail.message)) || 'Error adding products to cart');
      }

      await applyBundleDiscount();

      bundle = [];
    } catch (error) {
      console.error('Error:', error);
      showError("we couldn't add your bundle to the cart. please try again.");
    } finally {
      isSubmitting = false;
      if (submit) submit.classList.remove('loading');
      render();
    }
  }

  /* ---------- scrolling ---------- */

  function scrollToElement(element) {
    if (!element) return;
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET,
      behavior: 'smooth'
    });
  }

  // Keep the bundle box pinned beside the product lists, stopping at the bottom of the last one.
  function makeBundleSticky() {
    var bundleBoxRight = document.querySelector('.bundle-box-right');
    var container = bundleBoxRight && bundleBoxRight.closest('.col-md-4');
    var featuredBundles = document.querySelectorAll('.featured-bundle-area');

    if (!bundleBoxRight || !container || featuredBundles.length === 0 || window.innerWidth < 768) return;

    var lastFeaturedBundle = featuredBundles[featuredBundles.length - 1];
    var containerTop = container.offsetTop;
    var lastFeaturedBundleBottom = lastFeaturedBundle.offsetTop + lastFeaturedBundle.offsetHeight;

    function updateWidth() {
      bundleBoxRight.style.width = container.offsetWidth + 'px';
    }

    updateWidth();
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) {
        updateWidth();
        bundleBoxRight.style.display = 'block';
      } else {
        bundleBoxRight.style.position = '';
        bundleBoxRight.style.top = '';
        bundleBoxRight.style.width = '';
        bundleBoxRight.style.display = '';
      }
    });

    window.addEventListener('scroll', function () {
      if (window.innerWidth < 768) return;
      var scrollY = window.scrollY;
      var boxHeight = bundleBoxRight.offsetHeight;

      if (scrollY >= containerTop && scrollY + boxHeight < lastFeaturedBundleBottom) {
        bundleBoxRight.style.position = 'fixed';
        bundleBoxRight.style.top = '140px';
      } else if (scrollY + boxHeight >= lastFeaturedBundleBottom) {
        bundleBoxRight.style.position = 'absolute';
        bundleBoxRight.style.top = (lastFeaturedBundleBottom - boxHeight) + 'px';
      } else if (scrollY < containerTop) {
        bundleBoxRight.style.position = '';
        bundleBoxRight.style.top = '';
      }
    });
  }

  /* ---------- events ---------- */

  function setColumns(columns) {
    document.querySelectorAll('.product-grid > li').forEach(function (item) {
      item.classList.remove('grid--1-col', 'grid--2-col');
      item.classList.add('grid--' + columns + '-col');
    });
    document.querySelectorAll('.column-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-columns') === String(columns));
    });
  }

  function onClick(event) {
    var target = event.target;
    if (!target.closest) return;

    var removeIcon = target.closest('.remove-product');
    if (removeIcon) return removeUnit(removeIcon.getAttribute('data-pid'));

    var minus = target.closest('.minus-one');
    if (minus) return removeUnit(minus.getAttribute('data-product-id'));

    // Both the initial "+" and the "+" inside the quantity selector carry .add-to-bundle-btn.
    var add = target.closest('.add-to-bundle-btn');
    if (add) {
      if (add.disabled || add.classList.contains('disabled')) return;
      return addUnit(add);
    }

    var columnBtn = target.closest('.column-btn');
    if (columnBtn) return setColumns(parseInt(columnBtn.getAttribute('data-columns'), 10) || 1);

    if (target.closest('.caret-icon, .close-icon')) return toggleMobileBox();

    var doseButton = target.closest('.bundle-right-one');
    if (doseButton) {
      event.preventDefault();
      var area = doseButton.closest('.featured-bundle-area');
      return scrollToElement(area && area.querySelector('.bundle-slider-one'));
    }
  }

  function onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var control = event.target.closest && event.target.closest('.initial-plus-btn, .remove-product');
    if (!control) return;
    event.preventDefault();
    control.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id === 'product-bundle-form') {
      event.preventDefault();
      submitBundle();
    }
  });

  render();
  makeBundleSticky();
})();
